import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as CredentialsRoute } from './CredentialsRoute';

export default {
	actions,
	reducers,
	sagas
};
